var map = {
	"./ar.json": "a3ad",
	"./bg.json": "3bea",
	"./cs.json": "eb4e",
	"./de.json": "f89a",
	"./el.json": "b2c8",
	"./en.json": "7cb4",
	"./es.json": "fa30",
	"./et.json": "76f2",
	"./fi.json": "7657",
	"./fr.json": "54c6",
	"./hr.json": "dd8b",
	"./hu.json": "1cda",
	"./hy.json": "97d5",
	"./id.json": "40f1",
	"./it.json": "9c11",
	"./ka.json": "7b02",
	"./kk.json": "aef8",
	"./ko.json": "e6c0",
	"./lt.json": "c372",
	"./lv.json": "6da1",
	"./mk.json": "0f62c",
	"./nl.json": "072e",
	"./pl.json": "a2a7",
	"./pt.json": "6136",
	"./ro.json": "e67e",
	"./ru.json": "d3be",
	"./sk.json": "0946",
	"./sr.json": "99d9",
	"./sv.json": "ba6c",
	"./th.json": "1d0f",
	"./tr.json": "8930",
	"./uk.json": "0683",
	"./vi.json": "bb8a",
	"./zh.json": "56e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79db";